import { PlatformDomain } from "../../apis/mgmt/api";
import { FormWithConfig } from '../cconfig/FormWithConfig';
import { EditableProps } from '../common/Editable';
import { PlatformDomainForm } from './PlatformDomainForm';


export const PlatformDomainFormWithConfig = function (
    props: EditableProps<PlatformDomain>
) {
    
    const { data } = props;
    const platform = data?.platform?.slug;

    return (
        <FormWithConfig<PlatformDomain>
            formClass={PlatformDomainForm}
            formProps={props}
            domain={data?.domain?.slug}
            platform={platform}
            platformDomain={data?.slug}
            namespaces={`migglo.adapter.${platform},dynamic_.migglo.adapter.${platform}`}
        />
    );

};
